import { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { BRAND } from "@/data";

const LINKS = [
  { label: "The System", href: "#system" },
  { label: "Buy & Sell", href: "#services" },
  { label: "Areas", href: "#areas" },
  { label: "About Brett", href: "#about" },
  { label: "Reviews", href: "#reviews" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/90 backdrop-blur-xl border-b border-black/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <a href="#top" data-testid="brand-logo" className="leading-none">
          <span className="block font-serif text-2xl tracking-tight text-kw-ink">
            {BRAND.name}
          </span>
          <span className="overline text-[0.6rem] text-kw-red">
            {BRAND.brokerage}
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/[^a-z]/g, "")}`}
              className="text-sm font-medium text-neutral-600 hover:text-kw-red transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href={BRAND.phoneHref}
          data-testid="header-phone-cta"
          className="hidden sm:inline-flex items-center gap-2 bg-kw-red hover:bg-kw-redhover text-white px-5 py-2.5 transition-colors duration-300"
        >
          <Phone size={15} />
          <span className="text-sm font-semibold tracking-wide">{BRAND.phone}</span>
        </a>
      </div>
    </header>
  );
};
